/** Estados de listing para subastas (columna `listings.status`). */
export const AUCTION_LISTING_STATUS = {
  PENDING_VERIFICATION: 'auction_pending_verification',
  ACTIVE: 'active',
};

export const AUCTION_STATUS_LABEL_ES = {
  auction_pending_verification: 'Pendiente verificación',
  active: 'En vivo',
  sold: 'Vendida',
  removed: 'Retirada',
  paused: 'Pausada',
};

export function auctionStatusLabel(status) {
  const k = String(status || '').trim();
  return AUCTION_STATUS_LABEL_ES[k] || k || '—';
}

export function isAuctionLive(status) {
  return String(status || '').trim() === AUCTION_LISTING_STATUS.ACTIVE;
}

export function isAuctionPendingVerification(status) {
  return String(status || '').trim() === AUCTION_LISTING_STATUS.PENDING_VERIFICATION;
}
